export const ACADEMIC_LIST = [
  "Ensino Médio incompleto",
  "Ensino Médio completo",
  "Curso Técnico incompleto",
  "Curso Técnico completo",
  "Ensino Superior incompleto",
  "Ensino Superior completo",
  "Pós-gradução incompleto",
  "Pós-gradução completo",
  "Mestrado incompleto",
  "Mestrado completo",
  "Doutorado incompleto",
  "Doutorado completo",
  "Pós-doutorado",
];
